module.exports = __webpack_public_path__ + "images/emoji/ring.54082b1c17516d134c2f.png";